import { render, staticRenderFns } from "./stocksForExpeditionTable.vue?vue&type=template&id=44366094&"
import script from "./stocksForExpeditionTable.vue?vue&type=script&lang=ts&"
export * from "./stocksForExpeditionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports